document.addEventListener('DOMContentLoaded', function () {
  focusSuccessMessage();
  initExternalLinks();
});

function focusSuccessMessage() {
  const params = new URLSearchParams(window.location.search);
  const successMessage = document.getElementById('contact-form-success');

  if (params.get('contact_posted') === 'true' && successMessage) {
    // Remove Shopify's #contact_form positioning
    if (window.location.hash === '#contact_form') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    // Move focus to the success message
    successMessage.focus({ preventScroll: true });

    // Then scroll the success message into view
    successMessage.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
}
function initExternalLinks() {
  const links = document.querySelectorAll("a[href]");

  links.forEach((link) => {
    try {
      const href = link.getAttribute("href");
      if (!href) return;

      if (
        href.startsWith("#") ||
        href.startsWith("/") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:")
      ) {
        return;
      }

      const url = new URL(href, window.location.origin);

      if (url.hostname !== window.location.hostname) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");

        const label = link.getAttribute("aria-label") || link.textContent.trim();
        link.setAttribute("aria-label", `${label}, Redirecting to a third-party website (opens in a new tab).`);
      }
    } catch (err) {
      console.error("initExternalLinks: skipped a link due to error", link, err);
    }
  });
}

  window.onscroll = function () {
    toggleBackToTopButton();
  };
 
  function toggleBackToTopButton() {
    const backToTopButton = document.getElementById('back-to-top');
    const isMenuOpen = document.querySelector('.section-header.menu-open');
    if ((document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) && !isMenuOpen) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  }
 
  document.getElementById('back-to-top').onclick = function () {
    scrollToTop();
  };
 
  function scrollToTop() {
    const startPosition = window.scrollY;
    const duration = 500; // Duration in milliseconds
    let startTime = null;
 
    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1); // Ensure progress does not exceed 1
 
      // Easing function (easeOutCubic)
      const ease = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, startPosition * (1 - ease));
 
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }
 
    requestAnimationFrame(animation);
  }



  document.addEventListener("DOMContentLoaded", function () {
  function reorderHeaderDesktop() {
    const headerWrapper = document.querySelector(".header__wrapper");
    const logo = document.querySelector(".header__logo");
    const navigation = document.querySelector(".header__inline-navigation");

    if (!headerWrapper || !logo || !navigation) return;

    if (window.innerWidth >= 1200) {
      // Move logo before navigation on desktop
      if (headerWrapper.children[0] !== logo) {
        headerWrapper.insertBefore(logo, navigation);
      }
    } else {
      // Restore original mobile order
      const secondaryLinks = document.querySelector(".header__secondary-links");

      if (secondaryLinks && headerWrapper.children[1] !== logo) {
        headerWrapper.insertBefore(navigation, logo);
      }
    }
  }

  reorderHeaderDesktop();

  window.addEventListener("resize", reorderHeaderDesktop);
});

function addAltToTrackingImages() {
  document.querySelectorAll('img[src*="lantern.roeye.com/track.php"]').forEach(function(img) {
    img.setAttribute('alt', '');
  });
}

addAltToTrackingImages();

const observer = new MutationObserver(function() {
  addAltToTrackingImages();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.getElementById("result-q")?.setAttribute("aria-label", "Search");
document.getElementById("result-q")?.setAttribute("role", "button");

document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.getElementById('AddToCart');

  if (!addToCartBtn) return;

  const productForm = addToCartBtn.closest('form');
  if (!productForm) return;

  // Create success message box dynamically
  const successBox = document.createElement('div');
  successBox.id = 'cartSuccessMessage';
  successBox.style.display = 'none';
  successBox.style.marginTop = '10px';
  successBox.style.padding = '10px';
  successBox.style.background = '#e6ffed';
  successBox.style.border = '1px solid #2ecc71';
  successBox.style.borderRadius = '5px';
  successBox.style.fontSize = '14px';

  // Accessibility attributes - screen reader auto-announce
  successBox.setAttribute('role', 'status');
  successBox.setAttribute('aria-live', 'polite');
  successBox.setAttribute('aria-atomic', 'true');
  successBox.setAttribute('tabindex', '-1'); // programmatic focus ke liye

  successBox.innerHTML = `Product item has been added to the cart. 
    <a href="/cart" style="color:#0066cc; font-weight:bold; text-decoration:underline;">Click here to view cart</a>`;

  addToCartBtn.insertAdjacentElement('afterend', successBox);

  productForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(productForm);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(data => {
        successBox.style.display = 'block';

        // Screen reader ko force karna announce karne ke liye
        // (kuch browsers mein display:block hone ke baad bhi announce nahi hota, isliye focus shift kar rahe hain)
        setTimeout(() => {
          successBox.focus();
        }, 100);
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
        alert('Something went wrong. Please try again.');
      });
  });
});

document.querySelectorAll('.tabs-nav__item-list').forEach(function (tabList) {
  tabList.setAttribute('role', 'tablist');
});


document.querySelectorAll('.tabs-nav__item-list button').forEach(function (tab) {
  tab.setAttribute('role', 'tab');
});

// document.querySelectorAll('.tabs-nav__item-list button').forEach(function (tab) {
//   tab.setAttribute('role', 'tab');

//   const expanded = tab.getAttribute('aria-expanded');

//   tab.setAttribute(
//     'aria-selected',
//     expanded === 'true' ? 'true' : 'false'
//   );
// });

document.querySelectorAll('.tabs-nav__item-list button').forEach(function (tab) {
  tab.setAttribute('role', 'tab');

  function updateSelectedState() {
    const expanded = tab.getAttribute('aria-expanded');

    tab.setAttribute(
      'aria-selected',
      expanded === 'true' ? 'true' : 'false'
    );
  }

  // Set initial state
  updateSelectedState();

  // Watch for aria-expanded changes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'aria-expanded'
      ) {
        updateSelectedState();
      }
    });
  });

  observer.observe(tab, {
    attributes: true,
    attributeFilter: ['aria-expanded']
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("product-list.product-facet__product-list.product-list.anchor.became-visible .price, span.price.price--large").forEach(function (price) {
    if (
      !price.nextElementSibling ||
      !price.nextElementSibling.classList.contains("visually-hidden")
    ) {
      var hiddenText = document.createElement("span");
      hiddenText.className = "visually-hidden";
      hiddenText.textContent = "Regular Price";

      price.insertAdjacentElement("afterend", hiddenText);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("product-list.product-facet__product-list.product-list.anchor.became-visible span.price.price--highlight").forEach(function (price) {
    if (
      !price.nextElementSibling ||
      !price.nextElementSibling.classList.contains("visually-hidden")
    ) {
      var hiddenText = document.createElement("span");
      hiddenText.className = "visually-hidden";
      hiddenText.textContent = "Original Price";

      price.insertAdjacentElement("afterend", hiddenText);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("product-list.product-facet__product-list.product-list.anchor.became-visible span.price.price--highlight, .product__info span.price.price--large.price--highlight").forEach(function (price) {
    if (
      !price.nextElementSibling ||
      !price.nextElementSibling.classList.contains("visually-hidden")
    ) {
      var hiddenText = document.createElement("span");
      hiddenText.className = "visually-hidden";
      hiddenText.textContent = "Sale Price";

      price.insertAdjacentElement("afterend", hiddenText);
    }
  });
});